import React from 'react'

export const LoadingSkeleton = () => (
	<div className="animate-pulse w-full max-w-7xl mx-auto px-4 md:px-8 py-8">
		<div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
			<div className="lg:col-span-4 space-y-6">
				<div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
					<div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-4"></div>
					<div className="flex items-center mb-6">
						<div className="h-12 w-20 bg-gray-200 dark:bg-gray-700 rounded mr-4"></div>
						<div className="space-y-2">
							<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
							<div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
						</div>
					</div>
					<div className="space-y-2">
						{[1, 2, 3, 4, 5].map((i) => (
							<div key={i} className="flex items-center">
								<div className="w-16 h-3 bg-gray-200 dark:bg-gray-700 rounded"></div>
								<div className="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded mx-2"></div>
								<div className="w-6 h-3 bg-gray-200 dark:bg-gray-700 rounded"></div>
							</div>
						))}
					</div>
				</div>
				<div className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
					<div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-4"></div>
					<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full mb-2"></div>
					<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full mb-2"></div>
					<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
				</div>
			</div>
			<div className="lg:col-span-8">
				<div className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm mb-6">
					<div className="flex flex-col md:flex-row md:items-center gap-4">
						<div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg flex-1"></div>
						<div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg w-24"></div>
						<div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-lg w-32"></div>
					</div>
				</div>
				<div className="space-y-4">
					{[1, 2, 3].map((i) => (
						<div
							key={i}
							className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-sm">
							<div className="flex justify-between items-start mb-4">
								<div className="flex items-center">
									<div className="w-10 h-10 bg-gray-200 dark:bg-gray-700 rounded-full mr-3"></div>
									<div>
										<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24 mb-2"></div>
										<div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
									</div>
								</div>
								<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
							</div>
							<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4 mb-4"></div>
							<div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
						</div>
					))}
				</div>
			</div>
		</div>
	</div>
)
